export const BatchHighlightingOptions = [
  {
    name: "Students with pending login",
    _id: "pending_login",
    defaultSelected: true,
  },
  {
    name: "Students with no attempts",
    _id: "no_attempts",
  },
  {
    name: "Students with minimal attempts",
    _id: "minimal_attempts",
  },
  {
    name: "Low scoring students",
    _id: "lowest_scored",
  },
  {
    name: "Students with unfinished attempts",
    _id: "unfinished_attempts",
  },
  {
    name: "Students demonstrating improvement",
    _id: "demonstrating_improvement",
  },
  {
    name: "Dedicated students",
    _id: "deactivated_students",
  },
];

export const InterviewVariantTypes = {
  ASSESSMENT: 'assessment',
  VERBAL_MOCK: 'verbal_mock',
  VERBAL_IW: 'verbal_iw',
  CODING_MOCK: 'coding_mock',
  CODING_IW: 'coding_iw'
};

// Array version for easier iteration if needed
export const InterviewVariantTypeOptions = [
  { value: 'assessment', label: 'Assessment' },
  { value: 'verbal_mock', label: 'Verbal Mock' },
  { value: 'verbal_iw', label: 'Verbal Interview Wizard' },
  { value: 'coding_mock', label: 'Coding Mock' },
  { value: 'coding_iw', label: 'Coding Interview Wizard' }
];

export const DurationTypes = {
  THIS_WEEK: 'this_week',
  LAST_15_DAYS: 'last_15_days',
  LAST_MONTH: 'last_month',
  LAST_3_MONTHS: 'last_3_months'
};

// Array version compatible with Usage component
export const DurationOptions = [
  { _id: 'this_week', name: 'This Week' },
  { _id: 'last_15_days', name: 'Last 15 Days' },
  { _id: 'last_month', name: 'Last Month' },
  { _id: 'last_3_months', name: 'Last 3 Months' },
  { _id: 'all_time', name: 'All Time' }
];

export const LeaderboardOptions = [
  { _id: 'best_score', name: 'High Score' },
  { _id: 'most_dedicated', name: 'Most dedicated' },
];
        